(() => {
  const LOGOUT_HREF = "#account:a:logout";
  let allowNextLogoutClick = false;

  document.addEventListener(
    "click",
    (e) => {
      if (allowNextLogoutClick) return;

      // Works through shadow DOM
      const path = typeof e.composedPath === "function" ? e.composedPath() : [];
      const link = path.find(
        (node) =>
          node &&
          node.tagName === "A" &&
          typeof node.getAttribute === "function" &&
          node.getAttribute("href") === LOGOUT_HREF
      );

      if (!link) return;

      // Block the app's logout action until confirmed
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

      const ok = window.confirm("Are you sure you want to log out?");
      if (!ok) return;

      // Let the next click go through (so the app can handle it normally)
      allowNextLogoutClick = true;
      link.click();
      // reset immediately after
      setTimeout(() => (allowNextLogoutClick = false), 0);
    },
    true // capture so we intercept before the app handler
  );
})();